// 1. Define a type for the user object (customize with your actual user data)
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
// import { IUser } from "@/interfaces/user.interface";
import { callApi } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { IUser } from '@/interfaces/user.model';
import {
  IFiltersStates,
  INotification,
  INotificationCount,
} from '@/interfaces/common.model';
import moment from 'moment';
import { IEmployeeResponse } from '@/interfaces/employee.model';
// import { INotificationRespone } from '@/pages/Notification/Notification';
// import { getCurrentFinancialYear } from '@/utility/helper';
interface IUserState {
  isAuthenticated: boolean;
  user: IUser | null;
  isSideBarOpen: boolean;
  userWebsiteId: string;
  activeSidebarTab: number;
  scrollPosition: number;
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
  error: string | null;
  notification: INotification[] | null;
  notificationCount: INotificationCount | null;
  filtersStates: IFiltersStates;
  activeSalaryHeadTab: number;
  tableView: 'table' | 'grid';
  months: string[];
}
const initialState: IUserState = {
  filtersStates: {
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    sortByDate: [
      moment(moment().subtract(30, 'days').toDate()).format('YYYY-MM-DD'),
      moment(moment().toDate()).format('YYYY-MM-DD'),
    ],
    year: '',
    companyId: '',
    siteId: '',
    dashboardSiteId: '',
    department: '',
    designation: '',
    requestType: '',
    stockStatus: '',
    vendorId: '',
    empStatus: 'current',
    leaveType: '',
    leaveStatus: '',
    customerId: '',
    customerCompanyId: '',
    orderBy: '',
  },
  tableView: 'table',
  isAuthenticated: false,
  user: null,
  isSideBarOpen: false,
  scrollPosition: 0,
  activeSidebarTab: -1,
  userWebsiteId: '',
  loading: 'idle',
  notification: [],
  notificationCount: null,
  activeSalaryHeadTab: 1,
  error: null,
  months: [
    moment().startOf('month').format('YYYY-MM-DD'),
    moment().endOf('month').format('YYYY-MM-DD'),
  ],
};

// export const fetchNotificationCount = createAsyncThunk(
//   'user/fetchNotificationCount',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response: INotificationCountRes = await callApi(`${API_URL}${API_ENDPOINT?.getNotificationCount}`, {
//         method: 'GET',
//       });

//       // return response?.data?.count;
//       return response?.data;
//     } catch (error: unknown) {
//       let errorMessage = 'Failed to fetch notifications';
//       if (error instanceof Error) {
//         errorMessage = error.message;
//       }
//       return rejectWithValue(errorMessage);
//     }
//   },
// );

// export const fetchNotificationList = createAsyncThunk(
//   'user/fetchNotificationList',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response: INotificationRespone = await callApi(`${API_URL}${API_ENDPOINT?.getNotification}`, {
//         method: 'GET',
//       });

//       // return response?.data?.count;
//       return response?.data?.notification;
//     } catch (error: unknown) {
//       let errorMessage = 'Failed to fetch notifications';
//       if (error instanceof Error) {
//         errorMessage = error.message;
//       }
//       return rejectWithValue(errorMessage);
//     }
//   },
// );

export const fetchUserDetails = createAsyncThunk(
  'user/fetchUserDetails',
  async (_, { rejectWithValue }) => {
    try {
      const response: IEmployeeResponse = await callApi(
        `${API_URL}${API_ENDPOINT?.getProfile}`,
        {
          method: 'GET',
        },
      );
      return response?.data;
    } catch (error: unknown) {
      let errorMessage = 'Failed to fetch notifications';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      return rejectWithValue(errorMessage);
    }
  },
);
// export const logoutUser = createAsyncThunk(
//   'user/logout',
//   async (_, { rejectWithValue }) => {
//     const deviceId = localStorage.getItem(
//       import.meta.env.VITE_BUSINESS + 'deviceId',
//     );
//     const API = API_URL + API_ENDPOINT?.logout + `?deviceId=${deviceId}`;
//     try {
//       const response = await callApi<{
//         status: boolean;
//         message: string;
//       }>(API, {
//         method: 'GET',
//       });
//       if (response?.status) {
//         showToastNotification('success', response?.message);
//         store.dispatch(logout());
//         store.dispatch(setAuthenticated(false));
//         store.dispatch(setScrollPosition(0));
//         store.dispatch(setUserData(null));
//         store.dispatch(setUserWebsiteId(''));
//         store.dispatch(setSideBarOpen(0));
//         store.dispatch(setActiveSidebarTab(-1));
//         deleteCookies('token');
//         deleteCookies('refreshToken');
//         localStorage.removeItem('token');
//         localStorage.removeItem(import.meta.env.VITE_BUSINESS + 'deviceId');
//         window.location.href = '/';
//       }
//       // return response?.data?.count;
//     } catch (error: unknown) {
//       let errorMessage = 'Failed to fetch notifications';
//       if (error instanceof Error) {
//         errorMessage = error.message;
//       }
//       return rejectWithValue(errorMessage);
//     }
//   },
// );
// export const logoutUser = createAsyncThunk(
//   'user/logout',
//   async (_, thunkAPI) => {
//     const deviceId = localStorage.getItem(
//       import.meta.env.VITE_BUSINESS + 'deviceId',
//     );
//     const API = API_URL + API_ENDPOINT.logout + `?deviceId=${deviceId}`;
//     try {
//       const response = await callApi<{ status: boolean; message: string }>(
//         API,
//         {
//           method: 'GET',
//         },
//       );
//       if (response?.status) {
//         // logoutHandler(response?.message);
//         showToastNotification('success', response?.message);
//         thunkAPI.dispatch(logout());
//         thunkAPI.dispatch(setAuthenticated(false));
//         thunkAPI.dispatch(setScrollPosition(0));
//         thunkAPI.dispatch(setUserData(null));
//         thunkAPI.dispatch(setUserWebsiteId(''));
//         thunkAPI.dispatch(setSideBarOpen(0));
//         thunkAPI.dispatch(setActiveSidebarTab(-1));
//         deleteCookies('token');
//         deleteCookies('refreshToken');
//         localStorage.removeItem('token');
//         localStorage.removeItem(import.meta.env.VITE_BUSINESS + 'deviceId');
//         window.location.href = '/';
//       }
//     } catch (error: unknown) {
//       return thunkAPI.rejectWithValue('Failed to logout');
//     }
//   },
// );

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setScrollPosition: (state, action: PayloadAction<number>) => {
      state.scrollPosition = action.payload;
    },
    setUserData: (state, action: PayloadAction<null | IUser>) => {
      state.user = action.payload;
    },
    setUserWebsiteId: (state, action: PayloadAction<string>) => {
      state.userWebsiteId = action.payload;
    },
    setUpdateFilterStates: (
      state,
      action: PayloadAction<Partial<IFiltersStates>>,
    ) => {
      state.filtersStates = { ...state.filtersStates, ...action.payload };
    },
    setNotificationCount: (
      state,
      action: PayloadAction<INotificationCount>,
    ) => {
      state.notificationCount = action.payload;
    },
    setTableView: (state, action: PayloadAction<'table' | 'grid'>) => {
      state.tableView = action?.payload;
    },
    setNotification: (state, action: PayloadAction<INotification[] | null>) => {
      state.notification = action.payload;
    },
    setSideBarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSideBarOpen = action.payload;
    },
    setActiveSidebarTab: (state, action: PayloadAction<number>) => {
      state.activeSidebarTab = action.payload;
    },
    setActiveSalaryHeadTab: (state, action: PayloadAction<number>) => {
      state.activeSalaryHeadTab = action.payload;
    },
    setDateFilter: (state, action: PayloadAction<string[]>) => {
      state.months = action.payload;
    },
    logout: (state) => {
      Object.assign(state, initialState);
      state.isAuthenticated = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // .addCase(fetchNotificationCount.pending, (state) => {
      //   state.loading = 'pending';
      //   state.error = null;
      // })
      // .addCase(
      //   fetchNotificationCount.fulfilled,
      //   (state, action: PayloadAction<null | INotificationCount>) => {
      //     state.loading = 'succeeded';
      //     state.notificationCount = action.payload;
      //   },
      // )
      // .addCase(fetchNotificationCount.rejected, (state, action) => {
      //   state.loading = 'failed';
      //   state.error = action.payload as string;
      // })
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = 'pending';
        state.error = null;
      })
      .addCase(
        fetchUserDetails.fulfilled,
        (state, action: PayloadAction<null | IUser>) => {
          state.loading = 'succeeded';
          state.user = action.payload;
        },
      )
      .addCase(fetchUserDetails.rejected, (state) => {
        state.loading = 'failed';
        state.error = null;
      });
    // .addCase(fetchAttendanceStatus.fulfilled, (state, action) => {
    //   state.attendanceStatus = action.payload;
    // });
    // .addCase(fetchNotificationList.pending, (state) => {
    //   state.loading = 'pending';
    //   state.error = null;
    // })
    // .addCase(
    //   fetchNotificationList.fulfilled,
    //   (state, action: PayloadAction<null | INotification[]>) => {
    //     state.loading = 'succeeded';
    //     state.notification = action.payload;
    //   },
    // )
    // .addCase(fetchNotificationList.rejected, (state) => {
    //   state.loading = 'failed';
    //   state.error = null;
    // });
  },
});
export const {
  setAuthenticated,
  setUserData,
  setSideBarOpen,
  setActiveSidebarTab,
  logout,
  setScrollPosition,
  setUserWebsiteId,
  setActiveSalaryHeadTab,
  setUpdateFilterStates,
  setDateFilter,
  setNotification,
  setNotificationCount,
  setTableView,
} = userSlice.actions;
export const selectUserState = (state: RootState) => state.user;
export default userSlice.reducer;
